import {
  AddProductsToPricelistModalTranslation,
  DeletePricelistTranslation,
  EditPricelistTranslation,
  ExportPricelistToExcelModalTranslation,
  ExportPricelistToPdfModalTranslation,
  IncludeNetPriceTranslation,
  ModuleTranslation,
  NetPriceTranslation,
  PricelistDetailsTranslation,
  PricelistFormTranslation,
  PricelistsTranslation,
  ProductAccessoriesTranslation,
  ProductDetailsTranslation,
  ProductImageTranslation,
  ProductPricelistTranslation,
} from './ModuleTranslation';

const pricelistForm: PricelistFormTranslation = {
  name: {
    label: 'Naam',
    placeholder: 'Voer een naam in',
    maxLengthError: 'De naam mag niet langer zijn dan {maxLength} tekens.',
    requiredError: 'Voer een naam in.',
  },
  description: {
    label: 'Beschrijving',
    placeholder: 'Voer een korte beschrijving in',
    maxLengthError: 'De beschrijving mag niet langer zijn dan {maxLength} tekens.',
  },
  errors: {
    createFailed: 'De prijslijst kon niet worden aangemaakt. Probeer het opnieuw.',
    updateFailed: 'De prijslijst kon niet worden opgeslagen. Probeer het opnieuw.',
    nameAlreadyExists: 'Er bestaat al een prijslijst met deze naam. Gebruik een andere naam.',
  },
};

const addToPricelistModal: AddProductsToPricelistModalTranslation = {
  triggerLabel: 'Toevoegen aan Mijn prijslijsten',
  closeLabel: 'Sluiten',
  heading: 'Toevoegen aan Mijn prijslijsten',
  itemsToAddFormat: '{count} artikelen worden toegevoegd',
  addedToPricelistFormat: '{count} artikelen toegevoegd aan "{name}"',
  loadingLabel: 'Prijslijsten laden',
  modeLabel: 'Voeg de geselecteerde producten toe aan een bestaande of een nieuwe prijslijst',
  modes: {
    existing: 'Toevoegen aan bestaande',
    new: 'Nieuwe aanmaken',
  },
  cancelLabel: 'Annuleren',
  addLabel: 'Toevoegen',
  addPendingLabel: 'Toevoegen…',
  createLabel: 'Aanmaken',
  createPendingLabel: 'Aanmaken…',
  selectForm: {
    label: 'Selecteer prijslijst',
    addFailedError: 'De producten konden niet aan de prijslijst worden toegevoegd. Probeer het opnieuw.',
  },
  createForm: pricelistForm,
};

const netPrice: NetPriceTranslation = {
  label: 'Nettoprijs',
  notAvailable: 'n.v.t.',
};

const productAccessories: ProductAccessoriesTranslation = {
  basePrice: 'Basisprijs',
  itemNo: 'Artikelnr.',
  name: 'Beschrijving',
  price: 'Prijs',
  priceOnDemand: 'op aanvraag',
  netPrice,
};

const productPricelist: ProductPricelistTranslation = {
  basePrice: 'Basisprijs',
  heading: 'Prijslijst',
  price: 'Prijs',
  priceGroup: 'Prijsgroep',
  priceOnDemand: 'op aanvraag',
  netPrice,
};

const productImage: ProductImageTranslation = {
  enlargeImageFormat: 'Afbeelding van {name} vergroten',
};

const includeNetPrice: IncludeNetPriceTranslation = {
  label: 'Nettoprijzen opnemen',
  noAgreementsReason: 'Er zijn geen dealerovereenkomsten beschikbaar.',
};

const exportToExcelModal: ExportPricelistToExcelModalTranslation = {
  closeLabel: 'Sluiten',
  heading: 'Excel-export',
  generatingLabel: 'Even geduld, het bestand wordt aangemaakt.',
  readyLabel: 'Uw bestand is klaar.',
  errorLabel: 'Het bestand kon niet worden aangemaakt. Probeer het opnieuw.',
  exportLabel: 'Exporteren',
  downloadLabel: 'Downloaden',
  includeNetPrice,
};

const exportToPdfModal: ExportPricelistToPdfModalTranslation = {
  closeLabel: 'Sluiten',
  heading: 'PDF-export',
  titleInputLabel: 'Titel',
  titleInputPlaceholder: 'Voer een titel in',
  titleSubmitLabel: 'Bijwerken',
  loadingDataLabel: 'Even geduld, de producten worden geladen.',
  generatingLabel: 'Even geduld, het bestand wordt aangemaakt.',
  readyLabel: 'Uw bestand is klaar.',
  errorLabel: 'Het bestand kon niet worden aangemaakt. Probeer het opnieuw.',
  downloadLabel: 'Downloaden',
  includeNetPrice,
  document: {
    coverPage: {
      heading: 'Prijslijst',
      createdAtLabel: 'Aangemaakt',
      itemsLabel: 'Artikelen',
    },
    productSection: {
      itemNoLabel: 'Artikelnr.',
      detailsHeading: 'Productdetails',
      pricelist: productPricelist,
      additionalInfoHeading: 'Aanvullende informatie',
      accessories: {
        heading: 'Accessoires',
        table: productAccessories,
      },
    },
  },
};

const editPricelist: EditPricelistTranslation = {
  label: 'Bewerken',
  modal: {
    closeLabel: 'Sluiten',
    heading: 'Prijslijst bewerken',
    cancelLabel: 'Annuleren',
    submitLabel: 'Opslaan',
    submitPendingLabel: 'Opslaan…',
    form: pricelistForm,
  },
};

const deletePricelist: DeletePricelistTranslation = {
  label: 'Verwijderen',
  confirmationFormat: 'Weet u zeker dat u "{name}" wilt verwijderen? Dit kan niet ongedaan worden gemaakt.',
  successFormat: '"{name}" verwijderd',
  modal: {
    closeLabel: 'Sluiten',
    heading: 'Prijslijst verwijderen',
    cancelLabel: 'Annuleren',
    confirmLabel: 'Verwijderen',
    confirmPendingLabel: 'Verwijderen…',
    error: 'De prijslijst kon niet worden verwijderd. Probeer het opnieuw.',
  },
};

const pricelists: PricelistsTranslation = {
  pageTitleFormat: 'Prijslijsten',
  pageDescriptionFormat: 'Bekijk uw prijslijsten',
  tabs: {
    products: 'Producten',
    pricelists: 'Mijn prijslijsten',
  },
  pricelistListing: {
    searchPlaceholder: 'Zoeken',
    listsFoundLabel: 'Gevonden lijsten',
    loadingLabel: 'Prijslijsten laden',
    loadingMoreLabel: 'Meer prijslijsten laden',
    pricelistList: {
      pricelistListingEmpty: {
        message: 'Geen prijslijsten gevonden',
        createLabel: 'Maak een prijslijst aan',
      },
      pricelistListingItem: {
        itemsLabel: 'Artikelen:',
        createdAtLabel: 'Aangemaakt:',
        modifiedAtLabel: 'Laatst bewerkt:',
        actionsLabelFormat: 'Acties voor {name}',
      },
      itemActions: {
        edit: editPricelist,
        delete: deletePricelist,
      },
    },
    createPricelistModalTriggerLabel: 'Nieuwe prijslijst',
    createPricelistModal: {
      closeLabel: 'Sluiten',
      heading: 'Nieuwe prijslijst aanmaken',
      cancelLabel: 'Annuleren',
      submitLabel: 'Aanmaken',
      submitPendingLabel: 'Aanmaken…',
      form: pricelistForm,
    },
  },
  productListing: {
    title: 'Prijslijsten',
    searchPlaceholder: 'Zoeken',
    expansionToggle: {
      label: 'Alle productfamilies uit- of samenvouwen',
      options: {
        collapseAll: 'Alles samenvouwen',
        expandAll: 'Alles uitvouwen',
      },
    },
    productsFoundLabel: 'Gevonden producten',
    filters: {
      heading: 'Filters',
      brands: {
        label: 'Merk',
      },
      types: {
        label: 'Type',
      },
      sectors: {
        label: 'Ruimte',
      },
      priceRange: {
        label: 'Prijs',
        range: {
          from: 'Van',
          to: 'Tot',
        },
      },
    },
    table: {
      title: 'Producten',
      emptyText: 'Geen producten gevonden',
      loadingLabel: 'Producten laden',
      loadingMoreLabel: 'Meer producten laden',
      selectAll: 'Alle producten selecteren',
      selectProduct: 'Selecteren',
      expandFamily: 'Producten tonen',
      collapseFamily: 'Producten verbergen',
      expandColumnLabel: 'Uitvouwen',
      itemNo: 'Artikelnr.',
      image: 'Afbeelding',
      productImage,
      brand: 'Merk',
      model: 'Model',
      price: 'Prijs',
      priceInfo: {
        label: 'Prijsinformatie',
        content: 'Vanafprijzen. Prijzen variëren afhankelijk van de gekozen stoffen en opties.',
      },
      fromLabel: 'vanaf',
      productsCountLabel: 'producten',
      newBadge: 'NIEUW',
      modelActionLabel: 'Prijzen',
      familyActionLabel: 'Info',
      actionLabel: 'Actie',
    },
    selectionPanel: {
      selectedCountFormat: '{count} artikelen geselecteerd',
      export: 'Exporteren',
      clearSelection: 'Selectie wissen',
    },
    addToPricelistModal,
    exportToPdfModal,
    details: {
      closeLabel: 'Sluiten',
      loadingLabel: 'Details productfamilie laden',
      specificationHeading: 'Specificatie',
    },
    modelDetails: {
      closeLabel: 'Sluiten',
      loadingLabel: 'Prijzen laden',
      pricelist: {
        caption: 'Prijslijst',
        productGroup: 'PG',
        basePrice: 'Basisprijs',
        price: 'Prijs',
        priceOnDemand: 'op aanvraag',
        agreementDiscount: 'Dealerkorting volgens overeenkomst',
        netPrice,
      },
      detailsLinkLabel: 'Ga naar de productpagina voor gedetailleerde prijzen',
    },
  },
};

const productDetails: ProductDetailsTranslation = {
  pageTitleFormat: '',
  pageDescriptionFormat: 'Prijzen en accessoires voor {name}',
  backlinkLabel: 'Terug',
  downloadLabel: 'Downloaden',
  lastUpdatedLabel: 'Laatst bijgewerkt:',
  itemNoLabel: 'Artikelnr.',
  addToPricelistModal,
  exportToPdfModal,
  familyDetails: {
    triggerLabel: 'Details productfamilie',
    closeLabel: 'Sluiten',
    descriptionHeading: 'Beschrijving',
    featuresHeading: 'Kenmerken',
  },
  terms: {
    triggerLabel: 'Voorwaarden',
    closeLabel: 'Sluiten',
    heading: 'Algemene verkoop- en leveringsvoorwaarden',
    introFormat: 'Dit document is van toepassing op gecontracteerde distributeurs van {brand}.',
    loadingLabel: 'Voorwaarden laden',
  },
  closeLabel: 'Sluiten',
  productDetailsHeading: 'Productdetails',
  accessoriesHeading: 'Accessoires',
  additionalInfoHeading: 'Aanvullende informatie',
  pricelist: productPricelist,
  accessories: productAccessories,
};

const pricelistDetails: PricelistDetailsTranslation = {
  pageTitleFormat: '',
  pageDescriptionFormat: 'Prijzen voor de producten op {name}',
  backlinkLabel: 'Terug',
  exportLabel: 'Excel',
  downloadLabel: 'PDF/Afdrukken',
  settingsLabel: 'Instellingen',
  itemsLabel: 'Artikelen:',
  createdAtLabel: 'Aangemaakt:',
  modifiedAtLabel: 'Laatst bewerkt:',
  regionLabel: 'Regio',
  currencyLabel: 'Valuta',
  pricesRefreshedAtLabel: 'Prijzen bijgewerkt',
  currencyExcludingVatFormat: '{currency} (excl. btw)',
  searchPlaceholder: 'Zoeken',
  productsLabel: 'Producten op deze prijslijst',
  itemsFoundLabel: 'Artikelen',
  emptyText: 'Geen artikelen gevonden',
  loadingLabel: 'Artikelen laden',
  loadingMoreLabel: 'Meer artikelen laden',
  exportToExcelModal,
  exportToPdfModal,
  product: {
    actionsLabelFormat: 'Acties voor {name}',
    pricelist: productPricelist,
    productImage,
    additionalInfoHeading: 'Aanvullende informatie',
    accessories: {
      heading: 'Accessoires',
      loadingLabel: 'Accessoires laden',
      table: productAccessories,
    },
  },
  pricelistActions: {
    edit: editPricelist,
    delete: deletePricelist,
  },
  productActions: {
    remove: {
      label: 'Verwijderen',
      confirmationFormat: 'Weet u zeker dat u "{name}" van deze prijslijst wilt verwijderen?',
      successFormat: '"{name}" verwijderd',
      modal: {
        closeLabel: 'Sluiten',
        heading: 'Product verwijderen',
        cancelLabel: 'Annuleren',
        confirmLabel: 'Verwijderen',
        confirmPendingLabel: 'Verwijderen…',
        error: 'Het product kon niet worden verwijderd. Probeer het opnieuw.',
      },
    },
  },
};

const translation: ModuleTranslation = {
  pricelistDetails,
  pricelists,
  productDetails,
};

export default translation;
